module.exports = __webpack_public_path__ + "assets/4891dfec6aacd6f7d07f5192e386f7f2.gif";